/**
 * Copyright (c) 2019 2020 7thCode. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {IErrorObject} from "../../../../types/platform/universe";

import {Component, OnInit, ViewChild} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Overlay} from "@angular/cdk/overlay";

import {GridViewComponent} from "../../platform/base/components/gridview.component";
import {InquiryDialogComponent} from "./inquiry-dialog/inquiry-dialog.component";

import {SessionService} from "../../platform/base/services/session.service";
import {InquiriesService} from "./inquiries.service";

import {YesNoDialogComponent} from "../../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {MatPaginator} from "@angular/material/paginator";

/**
 * アーティクル
 *
 * @since 0.01
 */
@Component({
	selector: "inquiries",
	templateUrl: "./inquiries.component.html",
	styleUrls: ["./inquiries.component.css"],
})

export class InquiriesComponent extends GridViewComponent implements OnInit {

	@ViewChild('paginator') paginator: MatPaginator;

	public params: any = {};

	/**
	 *
	 * @param session
	 * @param overlay
	 * @param articleService
	 * @param matDialog
	 * @param snackbar
	 */
	constructor(
		protected session: SessionService,
		protected overlay: Overlay,
		protected matDialog: MatDialog,
		protected articleService: InquiriesService,
		private snackbar: MatSnackBar,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session, matDialog);
		this.service = articleService;
	}

	/**
	 * リストビューデコレータ
	 * @param object
	 */
	public toListView(object: any): any {
		object.cols = 1;
		object.rows = 1;
		return object;
	}

	/**
	 * ビューデコレータ
	 *
	 * @param data デコレーション対象
	 */
	public toView(data: any): any {
		return data;
	}

	/**
	 * トランスフォーマー
	 * @param data トランスフォーム対象
	 */
	public confirmToModel(data: any): any {
		return data;
	}

	/**
	 * エラー表示
	 * @param error
	 */
	private errorBar(error: IErrorObject): void {
		if (error) {
			this.snackbar.open(error.message, "Close", {
				duration: 8000,
			});
		}
	}

	/**
	 * メッセージ表示
	 * @param message
	 */
	private messageBar(message: string): void {
		if (message) {
			this.snackbar.open(message, "Close", {
				duration: 8000,
				panelClass: ["message-snackbar"]
			});
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.sort = {create: -1};
		super.ngOnInit();

		this.getSession((error: IErrorObject, session: object): void => {
			if (!error) {
				this.route.queryParams.subscribe(params => {
					this.params = params;
				});
			}
		});

	}

	/**
	 * アップデートダイアログ
	 * @param id ターゲット
	 */
	public updateDialog(id: string): void {
		this.get(id, (error: IErrorObject, result: any): void => {
			if (!error) {
				const dialog: MatDialogRef<any> = this.matDialog.open(InquiryDialogComponent, {
					width: '60%',
					minWidth: "320px",
					height: "fit-content",
					data: {content: this.toView(result)},
					disableClose: true,
				});

				dialog.beforeClosed().subscribe((result: any): void => {
					if (result) { // if not cancel then
						this.Progress(true);
						// 		result.content.status = 1;
						this.update(id, this.confirmToModel(result.content), (error: IErrorObject, result: any): void => {
							if (!error) {
								this.Complete("", result);
							} else {
								this.Complete("error", error);
							}
							this.Progress(false);
						});
					}
				});

				dialog.afterClosed().subscribe((result: any): void => {

				});

			} else {
				this.Complete("error", error);
			}
		});
	}

	/**
	 * 削除
	 * @param event
	 * @param id ターゲット
	 */
	public onDelete(event: any, id: string): void {

		const _delete = (id: string): void => {
			this.Progress(true);
			this.delete(id, (error: IErrorObject, result: any): void => {
				if (!error) {
					this.Complete("", result);
				} else {
					this.Complete("error", error);
				}
				this.Progress(false);
			});
		};

		if (event.shiftKey) { // dialog?
			_delete(id);
		} else {
			const resultDialogContent: any = {title: "Articles", message: "Delete this?"};
			const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
				width: "30%",
				minWidth: "320px",
				height: "fit-content",
				data: {
					session: this.currentSession,
					content: resultDialogContent,
				},
				disableClose: true,
			});
			dialog.afterClosed().subscribe((result: object): void => {
				if (result) { // if not cancel then
					_delete(id);
				}
			});
		}

	}

}
